import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError, Observable, catchError } from 'rxjs';
import { environment } from '../environments/environment';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class ApiKeyService {
  constructor(public http: HttpClient, private router: Router) {}
  headers = new HttpHeaders().set('Content-Type', 'application/json');

  base_url = environment.apiUrl;

  createApiKey(data: any): Observable<any> {
    return this.http
      .post(this.base_url + `api-keys`, data, {
        headers: this.headers,
      })
      .pipe(
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }
  getApiKeys(): Observable<any> {
    return this.http.get(this.base_url + 'api-keys').pipe(
      catchError((error: any) => {
        return throwError(error);
      })
    );
  }
  deleteApiKey(data: any): Observable<any> {
    return this.http.delete(this.base_url + `api-keys/${data}`).pipe(
      catchError((error: any) => {
        return throwError(error);
      })
    );
  }
  // deleteApiKey(data: any): Observable<any> {
  //   return this.http
  //     .delete(this.base_url + `organization/api-key`, { body: data })
  //     .pipe(
  //       catchError((error: any) => {
  //         return throwError(error);
  //       })
  //     );
  // }
}
